import { render, staticRenderFns } from "./PFLoader.vue?vue&type=template&id=bfdccb58&scoped=true&lang=html&"
import script from "./PFLoader.vue?vue&type=script&lang=js&"
export * from "./PFLoader.vue?vue&type=script&lang=js&"
import style0 from "./PFLoader.vue?vue&type=style&index=0&id=bfdccb58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfdccb58",
  null
  
)

export default component.exports